import React from 'react'
import ReactQuill from 'react-quill'
import MagicUrl from 'quill-magic-url'
import { Controller } from 'react-hook-form'

export default function RichTextInput({control}) {
  const Font = ReactQuill.Quill.import('formats/font')
  Font.whitelist = ['Helvetica Neue']
  ReactQuill.Quill.register(Font, true)
  ReactQuill.Quill.register('modules/magicUrl', MagicUrl)

  const modules = {
    toolbar: [
      [{size: []}],
      [{ 'font': Font.whitelist }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'align': []}],
      ['link', 'image', 'video'],
      ['clean']
    ],
    clipboard: { matchVisual: false, },
    magicUrl: true
  }
  /* 
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  const formats = [
    'size', 'font', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'align', 'link', 'image', 'video'
  ]

  return <div className='row about-league'>
    <div className='col-xs-12'>
      <link rel='stylesheet' href='https://unpkg.com/react-quill@1.3.3/dist/quill.snow.css' />
      <Controller
        control={control}
        name='about'
        defaultValue=''
        render={({ field }) => (
          <ReactQuill 
            theme='snow'
            modules={modules}
            formats={formats}
            value={field.value}
            onChange={text => field.onChange(text)}
          />
        )}
      />
    </div>
  </div>
}
